import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import ICONS from "../../../assets/Icons";
import TickerAnimation from "../../_utils/TickerAnimation";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import "./style.css";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import SVGComponent from "../../_utils/SVGComponent";

const ImageMapper = (provider) => {
  switch (provider) {
    case "gchat":
      return (
        <>
          <img
            src={ICONS?.GOOGLE_CHAT}
            alt="Google chat"
          />
        </>
      );
      break;
    case "slack":
      return (
        <>
          <img
            src={ICONS?.SLACK}
            alt="Slack"
          />
        </>
      );
      break;
    case "team":
      return (
        <>
          <img
            src={ICONS?.MICROSOFT_TEAMS}
            alt="Microsoft team"
          />
        </>
      );
      break;

    case "generic":
      return (
        <>
          <SVGComponent
            url={ICONS?.WEB_HOOK}
            color="var(--text-primary)"
            alt="Custom webhook"
          />
        </>
      );
      break;
    default:
      return "";
  }
};

const mapChannelLinkageStatus = (channelStatus) => {
  let data = [
    { status: "Pending", linkageStatus: "pending" },
    { status: "Success", linkageStatus: "verified" },
    { status: "Failed", linkageStatus: "failed" },
  ]?.filter((itm) => {
    if (itm?.linkageStatus?.toLowerCase().includes(channelStatus)) return itm;
  });

  return accountNameStandardised(data[0]?.status);
};

const ChannelViewallCard = ({
  channelData,
  showSearchBar,
  clearFilter,
  isSidebarOpen,
  filterRef,
  onChannelClick,
  setIsChannelViewallOpen,
  setLoadingDetail,
  isPopup,
  flowType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      {channelData?.length > GlobalConfiguration.lengthCheckZero && (
        <div className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md `}>
          {channelData?.map((data) => {
            return (
              <>
                <CardContainer
                  filterRef={filterRef}
                  hoverHeight={
                    GlobalConfiguration?.channelViewallCardHoverHeight
                  }
                  minHeight={GlobalConfiguration?.channelViewallCardHeight}
                  onClickHandler={(e) => {
                    if (isPopup) {
                      return;
                    }
                    if (!isSidebarOpen) {
                      if (onChannelClick) {
                        onChannelClick(data);
                      } else {
                        navigate(
                          `/home/notification_dashboard/channel_view_all/channel_detail_page/${data?.id}`,
                          {
                            state: {
                              isViewAll:
                                location?.pathname ===
                                "/home/notification_dashboard/channel_view_all"
                                  ? true
                                  : false,
                            },
                          },
                        );

                        setLoadingDetail?.(true);
                        setTimeout(() => {
                          setLoadingDetail?.(false);
                        }, IntervalConfiguration.intervalExtraLarge);

                        setIsChannelViewallOpen?.(false);
                      }
                    }
                  }}
                >
                  <card-body>
                    <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                      <div className="w-full flex justify-between items-center">
                        <p
                          className="text-font-sm flex-1 truncate font-normal"
                          style={{
                            color: "var(--text-primary)",
                          }}
                        >
                          <TickerAnimation
                            text={data?.name}
                            fontSize={"font-sm"}
                          />
                        </p>

                        <div className="flex gap-x-gap-sm ml-margin-sm justify-end"></div>
                      </div>

                      <p className="text-font-xs transform-none text-text-secondary">
                        Channel name
                      </p>
                    </div>

                    <div className="flex gap-x-gap-sm justify-between items-center">
                      {flowType === "notification" ? (
                        <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                          <div className="w-full flex justify-between items-center">
                            <p
                              className={`text-font-sm flex-1 truncate font-semibold ${
                                data?.is_active ? "text-settled" : "text-failed"
                              }`}
                            >
                              {data?.is_active ? "Active" : "Inactive"}
                            </p>
                          </div>

                          <p className="text-font-xs transform-none text-text-secondary">
                            Status
                          </p>
                        </div>
                      ) : (
                        <div
                          className={`flex flex-col px-padding-sm gap-y-gap-xs `}
                        >
                          <div className="w-full flex justify-between items-center">
                            <p
                              className="text-font-sm flex-1 truncate font-normal"
                              style={{
                                color: "var(--text-primary)",
                              }}
                            >
                              {formatDateViewAll(data?.created_at)}
                            </p>

                            <div className="flex gap-x-gap-sm ml-margin-sm justify-end"></div>
                          </div>

                          <p className="text-font-xs transform-none text-text-secondary">
                            Created on
                          </p>
                        </div>
                      )}

                      <div className="bg-text-primary   rounded-l-border-radius-md py-padding-xs px-padding-sm flex items-center ">
                        <div className="w-icon-sm h-icon-sm ">
                          {ImageMapper(data?.provider)}
                        </div>
                      </div>
                    </div>

                    {flowType === "notification" ? (
                      <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                        <div className="w-full flex justify-between items-center">
                          <p
                            className={`text-font-sm flex-1 truncate font-semibold ${
                              data?.verification_status === "pending"
                                ? "text-pending"
                                : data?.verification_status === "verified"
                                  ? "text-settled"
                                  : data?.verification_status === "failed"
                                    ? "text-failed"
                                    : ""
                            }`}
                          >
                            {mapChannelLinkageStatus(data?.verification_status)}
                          </p>
                        </div>

                        <p className="text-font-xs transform-none text-text-secondary">
                          Channel linkage
                        </p>
                      </div>
                    ) : (
                      <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                        <div className="w-full flex justify-between items-center">
                          <p
                            className={`text-font-sm flex-1 truncate font-semibold ${
                              data?.is_active ? "text-settled" : "text-failed"
                            }`}
                          >
                            {data?.is_active ? "Active" : "Inactive"}
                          </p>
                        </div>

                        <p className="text-font-xs transform-none text-text-secondary">
                          Status
                        </p>
                      </div>
                    )}
                  </card-body>
                  {flowType != "notification" && (
                    <card-hover>
                      <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                        <div className="w-full flex justify-between items-center">
                          <p
                            className={`text-font-sm flex-1 truncate font-semibold ${
                              data?.verification_status === "pending"
                                ? "text-pending"
                                : data?.verification_status === "verified"
                                  ? "text-settled"
                                  : data?.verification_status === "failed"
                                    ? "text-failed"
                                    : ""
                            }`}
                          >
                            {mapChannelLinkageStatus(data?.verification_status)}
                          </p>
                        </div>

                        <p className="text-font-xs transform-none text-text-secondary">
                          Channel linkage
                        </p>
                      </div>
                    </card-hover>
                  )}
                </CardContainer>
              </>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ChannelViewallCard;
